export default __webpack_public_path__ + "static/media/lead0.8fb7e163.svg";